<template>
  <!-- `click.stop` : la case vit dans la ligne « Email », qui copie l'adresse au
       clic ; cocher ne doit pas la copier. -->
  <BesoinFieldError class="bec" :error="error" section="personal" @click.stop>
    <span class="bec-row">
      <Checkbox
        :model-value="modelValue"
        label-text="Confirmée avec le client"
        aria-label="Adresse e-mail confirmée avec le client"
        variant="plain"
        no-wrapper
        :disabled="disabled || !emailValid"
        test-id="besoin-email-confirme"
        @update:model-value="$emit('update:modelValue', $event)"
      />
      <InfoHint :content="AIDE" test-id="besoin-email-aide" />
    </span>
    <!-- Case inactive : on dit pourquoi, sans attendre un refus. -->
    <span v-if="!emailValid && !disabled && !error" class="bec-warn">
      Adresse incomplète : corrigez-la d’abord.
    </span>
  </BesoinFieldError>
</template>

<script setup>
/**
 * LA CASE « CONFIRMÉE AVEC LE CLIENT », collée sous le champ Email de
 * « Informations personnelles », par l'emplacement `besoin-email` de
 * `QuoteDetailPersonalInfo` (la fiche de la demande ne le remplit pas : la
 * case n'y apparaît pas).
 *
 * DISCRÈTE (retour Figma du 2026-09-11, « visuellement c'est perturbant ») :
 * ni cadre ni fond autour de la case, qui passait pour un champ de plus ; le
 * texte d'aide demandé par Xavier, mot pour mot, vit dans le « i » au lieu de
 * s'étaler sur deux lignes ; une seule ligne d'état au plus en dessous.
 * L'état, lui, vient de `useBesoinEmailConfirm`.
 */
import { Checkbox, InfoHint } from '../ui'
import BesoinFieldError from './BesoinFieldError.vue'

const AIDE = 'Faites confirmer l’adresse e-mail au client et cochez cette case uniquement après avoir vérifié qu’elle ne contient aucune erreur ou coquille.'

defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  /** L'adresse saisie est-elle bien formée ? Sinon, rien à confirmer. */
  emailValid: {
    type: Boolean,
    default: true
  },
  /** Section confirmée ou devis signé. */
  disabled: {
    type: Boolean,
    default: false
  },
  /** Message affiché après un refus de confirmer la section. */
  error: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue'])
</script>

<style scoped>
.bec {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin-top: var(--spacing-2);
}

.bec-row {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
}

/* Refusée : le libellé passe en rouge, le message dessous suffit. */
.bec.bfe-invalid :deep(.checkbox-text) {
  color: var(--color-danger-dark);
}

.bec-warn {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-normal);
  color: var(--color-text-secondary);
}
</style>
